"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var session_storage_1 = __importDefault(require("../../utils/session-storage"));
var local_storage_1 = __importDefault(require("../local-storage"));
/**
 * Hook that checks display logic for the Painted Door Modal
 * Should return true only if:
 * - modal has not been seen in session (session storage logic)
 * - modal prompt has not been answered (local storage logic)
 * - current URL is either included in the list of allowed URLs passed, OR
 * - no URLs are passed (modal would display on all URLs)
 */
var useDisplayPaintedDoorModal = function (_a) {
    var includeURLs = _a.includeURLs, localStorageKey = _a.localStorageKey, sessionStorageKey = _a.sessionStorageKey;
    var sessionStorage = (0, session_storage_1.default)();
    var localStorage = (0, local_storage_1.default)();
    var result = (0, react_1.useMemo)(function () {
        var _a;
        var location = typeof window !== "undefined" ? (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname : null;
        var hasSeenModalInSession = sessionStorage.getItem(sessionStorageKey) === "true";
        var hasPaintedDoorPromptBeenAnswered = localStorage.getItem(localStorageKey) === "true";
        var onActiveURL = function () {
            if (includeURLs && location) {
                return includeURLs === null || includeURLs === void 0 ? void 0 : includeURLs.includes(location);
            }
            return true;
        };
        return (!hasSeenModalInSession &&
            !hasPaintedDoorPromptBeenAnswered &&
            onActiveURL());
    }, [includeURLs, localStorageKey, sessionStorageKey]);
    return result;
};
exports.default = useDisplayPaintedDoorModal;
